import React, {useState, useEffect, useContext} from 'react'
import api from './api/api'; 
import IntroductionContent from './IntroductionContent'
import { MessageContext } from './MessageContext';
import { useNavigate,useLocation } from 'react-router-dom';
import { isAuthenticated } from './api/api';


const FirstIntroduction = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setSelectedMessage } = useContext(MessageContext);
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0)
  const [currentCharIndex, setCurrentCharIndex] = useState(0)
  const [displayedMessages, setDisplayedMessages] = useState([])
  const [messages, setMessages] = useState([])

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/first-introduction-questions/`);
        const questions = response.data.map(q => q.question);
        setMessages(questions);
      } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          // 未認証の場合、ログイン画面にリダイレクト
          navigate('/login', { state: { from: location.pathname } });
        }  else {
          console.error('Error fetching first introduction:', error);
        }
      }
    }
    fetchQuestions();
  }, []);

  useEffect(() => {
    if (currentMessageIndex < messages.length) {
      const currentMessage = messages[currentMessageIndex]
      
      if (currentCharIndex < currentMessage.length) {
        const timer = setTimeout(() => {
          const updatedMessage = currentMessage.slice(0, currentCharIndex + 1)
          setDisplayedMessages(prevMessages => {
            const newMessages = [...prevMessages]
            newMessages[currentMessageIndex] = updatedMessage
            return newMessages
          })
          setCurrentCharIndex(prev => prev + 1)
        }, 2) // 50ミリ秒ごとに新しい文字を追加

        return () => clearTimeout(timer)
      } else {
        // メッセージが完了したら、次のメッセージへ
        setCurrentMessageIndex(prev => prev + 1)
        setCurrentCharIndex(0)
      }
    }
  }, [messages, currentMessageIndex, currentCharIndex])

  const handleMessageClick = (message) => {
    if (isAuthenticated()) {
      setSelectedMessage(message)
    } 
  }
  return (
    <div className="first-introduction">
      {displayedMessages.map((message, index) => (
        <IntroductionContent key={index} message={message} onClick={() => handleMessageClick(message)} />
      ))}
    </div>
  )
}

export default FirstIntroduction